(() => {
  if (document.body.classList.contains("is-505")) return;

  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const phoneMq = window.matchMedia("(max-width: 900px)");
  if (document.body.classList.contains("template-index")) {
    const canPan = (node) => {
      let el = node && node.nodeType === 1 ? node : node && node.parentElement;
      while (el && el !== document.body) {
        const y = getComputedStyle(el).overflowY;
        if ((y === "auto" || y === "scroll") && el.scrollHeight > el.clientHeight + 1) return true;
        el = el.parentElement;
      }
      return false;
    };
    document.addEventListener("touchmove", (e) => {
      if (!phoneMq.matches || e.touches.length > 1) return;
      if (e.target && e.target.closest && e.target.closest("[data-consent], .fh-consent, .os-win, .os-photos-fs")) return;
      if (!canPan(e.target)) e.preventDefault();
    }, { passive: false });
    ["gesturestart", "gesturechange", "gestureend"].forEach((ev) => {
      document.addEventListener(ev, (e) => {
        if (phoneMq.matches) e.preventDefault();
      }, { passive: false });
    });
  }
  document.addEventListener("dblclick", (e) => {
    if (phoneMq.matches) e.preventDefault();
  }, { capture: true });
  const deskMq = window.matchMedia("(min-width: 901px)");
  const deskMode = () => deskMq.matches;

  const routes = {
    shop: (window.FH && window.FH.routes && window.FH.routes.shop) || "/collections/all",
    info: (window.FH && window.FH.routes && window.FH.routes.info) || "/pages/about-us/main"
  };
  const APPS = ["videos", "photos", "play", "bin", "calc", "cmd", "browser", "sys", "a1z26", "recover", "laugh", "repair", "tried", "cons", "enter"];
  const ARG_WINS = new Set(["a1z26", "recover", "laugh", "repair", "tried", "cons", "enter"]);
  const sfx = (name) => {
    if (window.FH && typeof window.FH.playSfx === "function") window.FH.playSfx(name);
  };
  const FILE_STORE = "fh-os-files-v2";
  const WIN_STORE = "fh-os-wins-v2";
  const THRESHOLD = 16;
  const DEFAULT_FILES = {
    info: { left: 0.055, top: 0.12 },
    videos: { left: 0.055, top: 0.36 },
    photos: { left: 0.055, top: 0.60 },
    play: { left: 0.78, top: 0.12 },
    shop: { left: 0.78, top: 0.36 },
    bin: { left: 0.78, top: 0.60 },
    virus: { left: 0.42, top: 0.12 },
    enter: { left: 0.42, top: 0.36 }
  };

  const minmax = (n, a, b) => Math.min(b, Math.max(a, n));
  const desk = document.querySelector("[data-desk]");

  const readStore = (key) => {
    try { return JSON.parse(sessionStorage.getItem(key) || "{}") || {}; }
    catch (_) { return {}; }
  };
  const writeStore = (key, val) => {
    try { sessionStorage.setItem(key, JSON.stringify(val)); } catch (_) { /* */ }
  };

  const pinInBox = (el, box) => {
    const r = el.getBoundingClientRect();
    const x = r.left - box.left;
    const y = r.top - box.top;
    el.style.left = x + "px";
    el.style.top = y + "px";
    el.style.right = "auto";
    el.style.bottom = "auto";
    el.style.transform = "none";
    return { x, y };
  };

  const drag = ({ el, handle, origin, onMove, onEnd, onTap, onPick, skip, enabled }) => {
    const grip = handle || el;
    let live = false;
    let moved = false;
    let sx = 0;
    let sy = 0;
    let ox = 0;
    let oy = 0;
    let lastX = 0;
    let lastY = 0;
    let pid = null;

    const move = (e) => {
      if (!live || (pid !== null && e.pointerId !== pid)) return;
      const dx = e.clientX - sx;
      const dy = e.clientY - sy;
      if (!moved && (dx * dx + dy * dy) < THRESHOLD) return;
      if (!moved) {
        moved = true;
        el.classList.add("is-held");
        document.body.classList.add("is-os-drag");
        onPick && onPick();
      }
      const next = onMove(ox, oy, dx, dy, e);
      lastX = next.x;
      lastY = next.y;
      el.style.transform = `translate(${lastX - ox}px, ${lastY - oy}px)`;
    };

    const stop = (e) => {
      if (!live) return;
      if (e && pid !== null && e.pointerId !== pid && e.type !== "pointercancel") return;
      live = false;
      document.removeEventListener("pointermove", move);
      document.removeEventListener("pointerup", stop);
      document.removeEventListener("pointercancel", stop);
      document.body.classList.remove("is-os-drag");
      el.classList.remove("is-held");
      if (pid !== null) {
        try { grip.releasePointerCapture(pid); } catch (_) { /* */ }
      }
      pid = null;
      if (moved) {
        el.style.left = lastX + "px";
        el.style.top = lastY + "px";
        el.style.right = "auto";
        el.style.bottom = "auto";
        el.style.transform = "none";
        grip._osDragged = true;
        onEnd && onEnd(lastX, lastY);
      } else {
        el.style.transform = "none";
      }
      moved = false;
    };

    const down = (e) => {
      if (e.button && e.button !== 0) return;
      if (enabled && !enabled()) return;
      if (skip && skip(e)) return;
      const start = origin();
      live = true;
      moved = false;
      pid = e.pointerId;
      sx = e.clientX;
      sy = e.clientY;
      ox = start.x;
      oy = start.y;
      lastX = ox;
      lastY = oy;
      try { grip.setPointerCapture(pid); } catch (_) { /* */ }
      document.addEventListener("pointermove", move);
      document.addEventListener("pointerup", stop);
      document.addEventListener("pointercancel", stop);
    };

    grip.addEventListener("pointerdown", down);
    grip.addEventListener("click", (e) => {
      if (grip._osDragged) {
        e.preventDefault();
        e.stopPropagation();
        grip._osDragged = false;
        return;
      }
      if (onTap) onTap(e);
    });
  };

  const sheetHtml = (spec) =>
    `<div class="os-doc-open__sheet">
      <div class="os-doc-open__bar"><span>${spec.path || spec.title}</span><span>_ □ ×</span></div>
      <div class="os-doc-open__paper"><div class="os-doc-open__view"></div></div>
    </div>`;

  const PAGES = {
    info: {
      href: routes.info,
      title: "INFO.TXT",
      path: "C:\\FIVEHEARTS\\INFO.TXT",
      lines: ["WHAT IS FIVEHEARTS?", "A UK house of drawing, records, and a camera. The shop is one surface."]
    },
    shop: {
      href: routes.shop,
      title: "SHOP",
      path: "C:\\FIVEHEARTS\\SHOP",
      lines: ["The shop is one surface.", "Clothing / accessories / the drop."]
    }
  };

  let fileOpening = false;
  const fileOrigin = (fromEl) =>
    fromEl && (fromEl.querySelector(".os-file__ico, .os-dock__glyph, .desk-icon__glyph, .desk-icon__wings, .os-dock__wings") || fromEl);

  const pingFile = (fromEl) => {
    if (reduced || !fromEl) return;
    const el = fromEl.closest("[data-file], [data-open-win], [data-open-file], .os-dock__app, .desk-icon") || fromEl;
    el.classList.remove("is-launch");
    void el.offsetWidth;
    el.classList.add("is-launch");
    clearTimeout(el._osPing);
    el._osPing = setTimeout(() => el.classList.remove("is-launch"), 340);
  };

  const openDoc = (spec, fromEl) => {
    if (!spec || !spec.href || fileOpening) return;
    if (location.pathname.replace(/\/+$/, "") === new URL(spec.href, location.href).pathname.replace(/\/+$/, "")) return;
    pingFile(fromEl);
    sfx("open1");
    fileOpening = true;
    if (reduced || !deskMode()) {
      try { sessionStorage.setItem("fh-open-file", JSON.stringify({ title: spec.title })); } catch (_) { /* */ }
      location.href = spec.href;
      return;
    }
    const overlay = document.createElement("div");
    overlay.className = "os-doc-open";
    overlay.innerHTML = sheetHtml(spec);
    overlay.setAttribute("aria-hidden", "true");
    document.body.appendChild(overlay);
    const sheet = overlay.querySelector(".os-doc-open__sheet");
    const paper = overlay.querySelector(".os-doc-open__paper");
    const view = overlay.querySelector(".os-doc-open__view");
    const r = fileOrigin(fromEl) && fileOrigin(fromEl).getBoundingClientRect();
    if (r && r.width && r.height) {
      sheet.style.left = r.left + "px";
      sheet.style.top = r.top + "px";
      sheet.style.width = r.width + "px";
      sheet.style.height = r.height + "px";
    } else {
      sheet.style.left = "calc(50% - 22px)";
      sheet.style.top = "28%";
      sheet.style.width = "44px";
      sheet.style.height = "50px";
    }
    const fitView = () => {
      if (!paper || !view) return;
      const box = paper.getBoundingClientRect();
      const w = Math.max(1, innerWidth);
      const h = Math.max(1, innerHeight);
      view.style.width = w + "px";
      view.style.height = h + "px";
      view.style.transform = `scale(${box.width / w}, ${box.height / h})`;
    };
    let fitRaf = 0;
    const loopFit = () => {
      fitView();
      if (!go.done) fitRaf = requestAnimationFrame(loopFit);
    };
    const go = () => {
      if (go.done) return;
      go.done = true;
      cancelAnimationFrame(fitRaf);
      try { sessionStorage.setItem("fh-open-file", JSON.stringify({ title: spec.title })); } catch (_) { /* */ }
      location.href = spec.href;
    };
    let filled = false;
    let painted = false;
    let going = 0;
    const tryGo = () => {
      if (!filled || !painted || go.done || going) return;
      going = setTimeout(go, 140);
    };
    const fillPreview = (html) => {
      if (go.done || !view) return;
      try {
        const doc = new DOMParser().parseFromString(html, "text/html");
        doc.querySelectorAll("script, noscript, iframe, .boot, .fx-gl, .fx-shader, .fx-glyph, .fx-fault, .fx-orb, .tape-wipe, .cam").forEach((el) => el.remove());
        view.innerHTML = "";
        const take = (sel) => {
          const el = doc.querySelector(sel);
          if (!el) return false;
          const node = document.importNode(el, true);
          if (node.id) node.removeAttribute("id");
          node.querySelectorAll("[id]").forEach((n) => n.removeAttribute("id"));
          node.querySelectorAll("img").forEach((img) => {
            img.loading = "eager";
            img.decoding = "async";
          });
          view.appendChild(node);
          return true;
        };
        take(".tape");
        take(".desk-chrome");
        if (!take("#MainContent")) take("main");
        take(".os-dock");
      } catch (_) { /* */ }
      painted = true;
      tryGo();
    };
    fetch(spec.href, { credentials: "same-origin" })
      .then((res) => res.text())
      .then(fillPreview)
      .catch(() => {
        painted = true;
        tryGo();
      });
    void overlay.offsetWidth;
    overlay.classList.add("is-grow");
    loopFit();
    setTimeout(() => {
      overlay.classList.add("is-fill");
      sheet.addEventListener("transitionend", (e) => {
        if (e.propertyName === "width" || e.propertyName === "height" || e.propertyName === "left") {
          filled = true;
          tryGo();
        }
      });
      setTimeout(() => {
        filled = true;
        tryGo();
      }, 640);
    }, 360);
    setTimeout(() => {
      painted = true;
      tryGo();
    }, 1800);
  };

  const playEnter = () => {
    let spec = null;
    try {
      const raw = sessionStorage.getItem("fh-open-file");
      if (raw) spec = JSON.parse(raw);
    } catch (_) { /* */ }
    if (!spec || !spec.title) {
      document.documentElement.classList.remove("is-doc-hold", "is-doc-reveal");
      return;
    }
    try { sessionStorage.removeItem("fh-open-file"); } catch (_) { /* */ }
    sfx("open2");
    if (reduced) {
      document.documentElement.classList.remove("is-doc-hold", "is-doc-reveal");
      return;
    }
    requestAnimationFrame(() => {
      document.documentElement.classList.add("is-doc-reveal");
      setTimeout(() => {
        document.documentElement.classList.remove("is-doc-hold", "is-doc-reveal");
      }, 380);
    });
  };

  playEnter();

  const scrubDocOpen = () => {
    fileOpening = false;
    document.documentElement.classList.remove("is-doc-hold", "is-doc-reveal");
    document.querySelectorAll(".os-doc-open").forEach((el) => el.remove());
  };
  addEventListener("pageshow", (e) => {
    if (e.persisted) scrubDocOpen();
  });

  const front = (w) => {
    document.querySelectorAll(".os-win").forEach((x) => {
      x.classList.remove("is-front");
      if (x.classList.contains("is-open")) x.style.zIndex = "52";
    });
    w.classList.add("is-front");
    w.style.zIndex = "54";
  };

  const winLive = (w) => w && w.classList.contains("is-open") && !w.classList.contains("is-closing");
  const syncRail = () => {
    document.querySelectorAll("[data-open-win]").forEach((el) => {
      const name = el.getAttribute("data-open-win");
      const w = document.querySelector(`.os-win[data-win="${name}"]`);
      el.classList.toggle("is-now", winLive(w));
    });
    document.querySelectorAll("[data-file]").forEach((el) => {
      const name = el.getAttribute("data-file");
      const w = document.querySelector(`.os-win[data-win="${name}"]`);
      el.classList.toggle("is-now", winLive(w));
    });
  };

  const saveWin = (w) => {
    const name = w.getAttribute("data-win");
    if (!name || name === "a1z26") return;
    const all = readStore(WIN_STORE);
    all[name] = { left: parseFloat(w.style.left) || 0, top: parseFloat(w.style.top) || 0 };
    writeStore(WIN_STORE, all);
  };

  const phoneSheet = () => {
    const pad = 6;
    const bar = document.querySelector(".os-bar");
    const dock = document.querySelector(".os-dock");
    const top = bar ? Math.round(bar.getBoundingClientRect().bottom) : 40;
    const bottom = dock ? Math.round(dock.getBoundingClientRect().top) : innerHeight - 72;
    return {
      x: pad,
      y: top,
      w: Math.max(80, innerWidth - pad * 2),
      h: Math.max(80, bottom - top)
    };
  };

  const finishOpen = (w) => {
    w.classList.remove("is-opening");
    w.style.width = "";
    w.style.height = "";
    w.style.overflow = "";
    if (!deskMode()) {
      w.style.left = "";
      w.style.top = "";
      w.style.right = "";
      w.style.bottom = "";
    }
  };

  const clampWin = (w, x, y) => {
    if (!deskMode()) {
      return { x: 0, y: 0 };
    }
    const topBar = 40;
    const botBar = 78;
    const maxX = Math.max(8, innerWidth - 12 - w.offsetWidth);
    const maxY = Math.max(topBar, innerHeight - botBar - w.offsetHeight);
    return { x: minmax(x, 8, maxX), y: minmax(y, topBar, maxY) };
  };

  const parkWin = (w, n) => {
    if (!deskMode()) {
      const box = phoneSheet();
      w.style.left = box.x + "px";
      w.style.top = box.y + "px";
      w.style.width = box.w + "px";
      w.style.height = box.h + "px";
      w.style.right = "auto";
      w.style.bottom = "auto";
      w.style.transform = "none";
      w.dataset.parked = "1";
      return;
    }
    const name = w.getAttribute("data-win");
    if (name === "a1z26") {
      const ww = w.offsetWidth || 320;
      const hh = Math.min(w.offsetHeight || 280, innerHeight - 72);
      const p = clampWin(w, (innerWidth - ww) / 2, (innerHeight - hh) / 2);
      w.style.left = p.x + "px";
      w.style.top = p.y + "px";
      w.style.right = "auto";
      w.style.bottom = "auto";
      w.style.transform = "none";
      w.dataset.parked = "1";
      return;
    }
    const saved = readStore(WIN_STORE)[name];
    if (saved && Number.isFinite(saved.left) && Number.isFinite(saved.top)) {
      const p = clampWin(w, saved.left, saved.top);
      w.style.left = p.x + "px";
      w.style.top = p.y + "px";
    } else {
      const left = innerWidth * (0.12 + (n % 4) * 0.04);
      const top = innerHeight * (0.14 + (n % 4) * 0.05);
      const p = clampWin(w, left, top);
      w.style.left = p.x + "px";
      w.style.top = p.y + "px";
    }
    w.style.right = "auto";
    w.style.bottom = "auto";
    w.style.transform = "none";
    w.dataset.parked = "1";
  };

  const winOrigin = (name, fromEl) =>
    fileOrigin(fromEl) ||
    fileOrigin(document.querySelector(`[data-file="${name}"]`)) ||
    fileOrigin(document.querySelector(`[data-open-win="${name}"]`));

  const gated = (name) => {
    const arg = window.FH && window.FH.arg;
    if (!arg || !arg.gate) return name !== "enter" && name !== "cons" && name !== "repair" && name !== "tried";
    return arg.gate(name);
  };

  const syncTask = () => {
    const rail = document.querySelector("[data-task-tabs]");
    if (!rail) return;
    rail.innerHTML = "";
    document.querySelectorAll(".os-win.is-open").forEach((w) => {
      const name = w.getAttribute("data-win");
      if (!name) return;
      const tab = document.createElement("button");
      tab.type = "button";
      tab.className = "desk-task__tab" + (w.classList.contains("is-front") ? " is-now" : "");
      let title = (w.querySelector(".os-win__bar span") || {}).textContent || name;
      title = String(title).replace(/^C:\\FIVEHEARTS\\/i, "");
      tab.textContent = title;
      tab.addEventListener("click", () => openWin(name));
      rail.appendChild(tab);
    });
  };

  const bootWin = (name) => {
    document.dispatchEvent(new CustomEvent("fh:win", { detail: { name, action: "open" } }));
    if (name === "photos" && window.FH && typeof window.FH.photosOpen === "function") {
      window.FH.photosOpen();
    }
  };

  const openWin = (name, fromEl) => {
    if (!gated(name)) return;
    const w = document.querySelector(`.os-win[data-win="${name}"]`);
    if (!w) return;
    pingFile(fromEl || document.querySelector(`[data-file="${name}"]`));
    if (w.classList.contains("is-closing")) return;
    if (w.classList.contains("is-open")) {
      front(w);
      w.classList.remove("is-poke");
      void w.offsetWidth;
      w.classList.add("is-poke");
      clearTimeout(w._osPoke);
      w._osPoke = setTimeout(() => w.classList.remove("is-poke"), 280);
      syncRail();
      syncTask();
      bootWin(name);
      return;
    }
    if (name === "cmd") sfx("cmd");
    else if (name === "calc") sfx("calc");
    else if (!ARG_WINS.has(name)) sfx("open");
    w.hidden = false;
    w.classList.add("is-open", "is-opening");
    w.style.transition = "none";
    const n = document.querySelectorAll(".os-win.is-open").length;
    parkWin(w, n);
    const dest = {
      x: parseFloat(w.style.left) || 0,
      y: parseFloat(w.style.top) || 0,
      w: w.offsetWidth,
      h: deskMode() ? Math.min(w.offsetHeight, innerHeight - 48) : w.offsetHeight
    };
    const origin = winOrigin(name, fromEl);
    const r = origin && origin.getBoundingClientRect();
    const zoom = !!(r && r.width && !reduced);
    if (zoom) {
      w.style.left = r.left + "px";
      w.style.top = r.top + "px";
      w.style.width = r.width + "px";
      w.style.height = r.height + "px";
      w.style.overflow = "hidden";
    }
    void w.offsetWidth;
    w.style.transition = "";
    if (zoom) {
      w.style.left = dest.x + "px";
      w.style.top = dest.y + "px";
      w.style.width = dest.w + "px";
      w.style.height = dest.h + "px";
    }
    bootWin(name);
    if (zoom) {
      clearTimeout(w._osOpenT);
      w._osOpenT = setTimeout(() => {
        if (w.classList.contains("is-closing")) return;
        finishOpen(w);
        if (name === "photos" && deskMode()) {
          const p = clampWin(w, parseFloat(w.style.left) || 0, parseFloat(w.style.top) || 0);
          w.style.left = p.x + "px";
          w.style.top = p.y + "px";
        }
      }, 460);
    } else {
      finishOpen(w);
    }
    front(w);
    syncRail();
    syncTask();
  };

  const closeWin = (w) => {
    if (!w || !w.classList.contains("is-open") || w.classList.contains("is-closing")) return;
    const name = w.getAttribute("data-win");
    if (name === "cmd" || !ARG_WINS.has(name)) sfx("close");
    const origin = winOrigin(name);
    const r = origin && origin.getBoundingClientRect();
    clearTimeout(w._osOpenT);
    if (r && r.width && !reduced) {
      const box = w.getBoundingClientRect();
      w.classList.add("is-opening", "is-closing");
      w.style.left = box.left + "px";
      w.style.top = box.top + "px";
      w.style.width = box.width + "px";
      w.style.height = box.height + "px";
      w.style.right = "auto";
      w.style.bottom = "auto";
      w.style.overflow = "hidden";
      void w.offsetWidth;
      w.style.left = r.left + "px";
      w.style.top = r.top + "px";
      w.style.width = r.width + "px";
      w.style.height = r.height + "px";
      setTimeout(() => {
        w.classList.remove("is-open", "is-front", "is-opening", "is-closing");
        w.hidden = true;
        w.style.width = "";
        w.style.height = "";
        w.style.overflow = "";
        w.style.left = "";
        w.style.top = "";
        syncRail();
        syncTask();
        document.dispatchEvent(new CustomEvent("fh:win", { detail: { name, action: "close" } }));
      }, 430);
      syncRail();
      syncTask();
      return;
    }
    w.classList.remove("is-open", "is-front", "is-opening", "is-closing");
    w.hidden = true;
    w.style.width = "";
    w.style.height = "";
    w.style.overflow = "";
    w.style.left = "";
    w.style.top = "";
    syncRail();
    syncTask();
    document.dispatchEvent(new CustomEvent("fh:win", { detail: { name, action: "close" } }));
  };

  const runFile = (name, fromEl) => {
    if (name === "virus" || name === "enter") {
      if (window.FH && window.FH.arg && window.FH.arg.onFile) window.FH.arg.onFile(name, fromEl);
      return;
    }
    if (PAGES[name]) {
      openDoc(PAGES[name], fromEl);
      return;
    }
    if (APPS.includes(name)) {
      openWin(name, fromEl);
      return;
    }
  };

  document.querySelectorAll("[data-open-win]").forEach((el) => {
    el.addEventListener("click", (e) => {
      e.preventDefault();
      openWin(el.getAttribute("data-open-win"), el);
    });
  });
  document.querySelectorAll("[data-open-file]").forEach((el) => {
    el.addEventListener("click", (e) => {
      e.preventDefault();
      const key = el.getAttribute("data-open-file");
      openDoc(PAGES[key] || PAGES.info, el);
    });
  });
  document.querySelectorAll("[data-close-win]").forEach((el) => {
    el.addEventListener("click", (e) => {
      e.preventDefault();
      closeWin(el.closest(".os-win"));
    });
  });

  const bindWin = (win) => {
    if (!win || win._osBound) return;
    win._osBound = true;
    win.addEventListener("pointerdown", () => {
      if (win.classList.contains("is-open")) front(win);
      syncTask();
    });
    const bar = win.querySelector("[data-win-drag]");
    if (!bar) return;
    drag({
      el: win,
      handle: bar,
      enabled: deskMode,
      skip: (e) => !!e.target.closest("[data-close-win]"),
      origin: () => {
        front(win);
        const r = win.getBoundingClientRect();
        win.style.left = r.left + "px";
        win.style.top = r.top + "px";
        win.style.right = "auto";
        win.style.bottom = "auto";
        win.style.transform = "none";
        return { x: r.left, y: r.top };
      },
      onMove: (ox, oy, dx, dy) => clampWin(win, ox + dx, oy + dy),
      onEnd: (x, y) => {
        win.style.left = x + "px";
        win.style.top = y + "px";
        saveWin(win);
      }
    });
  };

  document.querySelectorAll(".os-win").forEach(bindWin);

  /* —— desktop files —— */
  const saveFiles = () => {
    if (!desk) return;
    const all = {};
    desk.querySelectorAll("[data-file]").forEach((el) => {
      all[el.getAttribute("data-file")] = {
        left: parseFloat(el.style.left) || 0,
        top: parseFloat(el.style.top) || 0
      };
    });
    writeStore(FILE_STORE, all);
  };

  let layoutTries = 0;
  const deskReady = (box) => box.width >= 240 && box.height >= Math.min(420, innerHeight * 0.5);

  const placeDefault = (el, box) => {
    const slot = DEFAULT_FILES[el.getAttribute("data-file")] || { left: 0.08, top: 0.12 };
    const maxX = Math.max(0, box.width - el.offsetWidth);
    const maxY = Math.max(0, box.height - el.offsetHeight);
    el.style.left = minmax(slot.left * box.width, 0, maxX) + "px";
    el.style.top = minmax(slot.top * box.height, 0, maxY) + "px";
    el.style.right = "auto";
    el.style.bottom = "auto";
    el.style.transform = "none";
  };

  const savedLooksStuck = (saved, box) => {
    const spots = Object.values(saved).filter((p) => p && Number.isFinite(p.top));
    if (!spots.length) return true;
    const maxTop = Math.max(...spots.map((p) => p.top));
    return maxTop < Math.min(140, box.height * 0.22);
  };

  const layoutFiles = () => {
    if (!desk) return;
    if (!deskMode()) {
      layoutTries = 0;
      desk.querySelectorAll("[data-file]").forEach((el) => {
        el.style.transform = "none";
      });
      return;
    }
    const box = desk.getBoundingClientRect();
    if (!deskReady(box)) {
      if (layoutTries++ < 60) requestAnimationFrame(layoutFiles);
      return;
    }
    layoutTries = 0;
    const saved = readStore(FILE_STORE);
    const useSaved = saved && !savedLooksStuck(saved, box);
    desk.querySelectorAll("[data-file]").forEach((el) => {
      const name = el.getAttribute("data-file");
      const keep = useSaved && saved[name];
      const maxX = Math.max(0, box.width - el.offsetWidth);
      const maxY = Math.max(0, box.height - el.offsetHeight);
      if (keep && Number.isFinite(keep.left) && Number.isFinite(keep.top)) {
        el.style.left = minmax(keep.left, 0, maxX) + "px";
        el.style.top = minmax(keep.top, 0, maxY) + "px";
        el.style.right = "auto";
        el.style.bottom = "auto";
        el.style.transform = "none";
      } else {
        placeDefault(el, box);
      }
    });
  };

  const bindFiles = () => {
    if (!desk) return;
    desk.querySelectorAll("[data-file]").forEach((el) => {
      if (el._osBound) return;
      el._osBound = true;
      if (!el.hasAttribute("data-drag")) {
        el.addEventListener("click", () => runFile(el.getAttribute("data-file"), el));
        return;
      }
      el.addEventListener("dragstart", (e) => e.preventDefault());
      drag({
        el,
        enabled: deskMode,
        origin: () => pinInBox(el, desk.getBoundingClientRect()),
        onMove: (ox, oy, dx, dy) => {
          const box = desk.getBoundingClientRect();
          const maxX = Math.max(0, box.width - el.offsetWidth);
          const maxY = Math.max(0, box.height - el.offsetHeight);
          return {
            x: minmax(ox + dx, 0, maxX),
            y: minmax(oy + dy, 0, maxY)
          };
        },
        onPick: () => sfx("pick"),
        onEnd: () => {
          sfx("drop");
          saveFiles();
        },
        onTap: () => runFile(el.getAttribute("data-file"), el)
      });
    });
  };

  bindFiles();
  const kickLayout = () => requestAnimationFrame(() => requestAnimationFrame(layoutFiles));
  kickLayout();
  addEventListener("load", kickLayout);
  deskMq.addEventListener("change", kickLayout);
  addEventListener("resize", () => {
    if (document.body.classList.contains("is-os-drag")) return;
    if (!deskMode()) return;
    layoutFiles();
    document.querySelectorAll(".os-win.is-open").forEach((w) => {
      const p = clampWin(w, parseFloat(w.style.left) || 0, parseFloat(w.style.top) || 0);
      w.style.left = p.x + "px";
      w.style.top = p.y + "px";
    });
  });

  /* —— tape TV (stays on the OS) —— */
  const tv = document.querySelector("[data-os-tv]");
  const tvFrame = document.querySelector("[data-os-tv-frame]");
  const closeTv = () => {
    if (!tv) return;
    tv.classList.remove("is-open");
    if (tvFrame) tvFrame.src = "";
    clearTimeout(tv._osTvT);
    tv._osTvT = setTimeout(() => { tv.hidden = true; }, 280);
  };
  const openTv = (id) => {
    if (!tv || !tvFrame || !id) return;
    tv.hidden = false;
    tv.classList.remove("is-open");
    void tv.offsetWidth;
    tv.classList.add("is-open");
    tvFrame.src = "https://www.youtube.com/embed/" + id + "?autoplay=1";
  };
  document.querySelectorAll("[data-tape]").forEach((el) => {
    el.addEventListener("click", (e) => {
      e.preventDefault();
      openTv(el.getAttribute("data-tape"));
    });
  });
  document.querySelectorAll("[data-os-tv-x]").forEach((el) => {
    el.addEventListener("click", (e) => {
      e.preventDefault();
      closeTv();
    });
  });
  tv && tv.addEventListener("click", (e) => {
    if (e.target === tv) closeTv();
  });

  addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    if (document.body.classList.contains("is-storming")) return;
    if (tv && !tv.hidden) {
      closeTv();
      return;
    }
    const frontWin = document.querySelector(".os-win.is-front.is-open") || document.querySelector(".os-win.is-open");
    closeWin(frontWin);
  });

  if (new URLSearchParams(location.search).get("play") === "1") openWin("play");
  const winQ = new URLSearchParams(location.search).get("win");
  if (winQ === "info") openDoc(PAGES.info, document.querySelector('[data-file="info"]'));
  else if (winQ && APPS.includes(winQ)) openWin(winQ, document.querySelector(`[data-file="${winQ}"]`));

  /* text-mode shapes — high contrast wire, not vaporwave */
  const glyph = document.getElementById("FxGlyph");
  if (glyph && !reduced) {
    const ctx = glyph.getContext("2d");
    const chars = " .:-+*=#@";
    let mx = 0.5;
    let my = 0.4;
    let running = true;
    addEventListener("pointermove", (e) => {
      mx = e.clientX / innerWidth;
      my = e.clientY / innerHeight;
    }, { passive: true });
    document.addEventListener("visibilitychange", () => { running = !document.hidden; });
    const fit = () => {
      glyph.width = 96;
      glyph.height = 54;
    };
    fit();
    addEventListener("resize", fit);
    const draw = (now) => {
      if (!running) {
        requestAnimationFrame(draw);
        return;
      }
      const w = glyph.width;
      const h = glyph.height;
      const t = now * 0.001;
      ctx.fillStyle = "#000";
      ctx.fillRect(0, 0, w, h);
      ctx.font = "10px monospace";
      ctx.textBaseline = "top";
      const broken = document.body.classList.contains("is-broken");
      const storm = document.body.classList.contains("is-storming");
      const t2 = broken ? t * (storm ? 1.6 : 1.15) : t;
      const rowHit = broken && Math.random() > (storm ? 0.72 : 0.86);
      const skipRow = rowHit ? Math.floor(Math.random() * (h / 8)) : -1;
      for (let y = 0; y < h; y += 8) {
          const row = y / 8;
          if (row === skipRow) continue;
          const rowShift = broken && Math.random() > (storm ? 0.82 : 0.9) ? (Math.random() - 0.5) * (storm ? 10 : 6) : 0;
        for (let x = 0; x < w; x += 6) {
          const nx = x / w - 0.5;
          const ny = y / h - 0.45;
          const z = Math.sin(nx * (broken ? 14 : 8) + t2) * Math.cos(ny * 7 - t2 * 0.8);
          const d = Math.hypot(nx - (mx - 0.5), ny - (my - 0.5));
          const v = 0.55 + z * 0.35 - d * 0.8 + (broken ? Math.sin(t2 * 9 + y) * 0.2 : 0);
          const i = Math.max(0, Math.min(chars.length - 1, Math.floor(v * chars.length)));
          ctx.fillStyle = broken && (i > 4 || Math.random() > 0.82) ? "#c4122e" : (i > 6 ? "#c4122e" : "#f4f1ec");
          ctx.globalAlpha = (broken ? 0.28 : 0.15) + i / 18;
          ctx.fillText(chars[i], x + rowShift, y);
        }
      }
      ctx.globalAlpha = broken ? 0.9 : 0.55;
      if (!broken) {
        ctx.strokeStyle = "#c4122e";
        ctx.beginPath();
        ctx.moveTo(0, h * 0.72);
        ctx.lineTo(w, h * 0.72);
        ctx.stroke();
      }
      requestAnimationFrame(draw);
    };
    draw(0);
  }

  const spawnFile = (name, label, over) => {
    if (!desk) return null;
    let el = desk.querySelector(`[data-file="${name}"]`);
    if (el) return el;
    el = document.createElement("button");
    el.className = "os-file";
    el.type = "button";
    el.setAttribute("data-file", name);
    el.setAttribute("data-drag", "");
    el.innerHTML = `<span class="os-file__ico os-file__ico--dir" aria-hidden="true"><img class="os-file__over" src="${over}" alt="" width="56" height="55"></span><span class="os-file__name">${label}</span>`;
    desk.appendChild(el);
    bindFiles();
    layoutFiles();
    return el;
  };

  const dropFile = (name) => {
    if (!desk) return;
    const el = desk.querySelector(`[data-file="${name}"]`);
    if (el) el.remove();
    const all = readStore(FILE_STORE);
    if (all[name]) {
      delete all[name];
      writeStore(FILE_STORE, all);
    }
  };

  const resetDesk = () => {
    dropFile("virus");
    dropFile("enter");
    try { sessionStorage.setItem("fh.drop", JSON.stringify({ virus: 1, enter: 1 })); } catch (_) { /* */ }
    const calc = document.querySelector("[data-calc-display]");
    if (calc) calc.value = "";
    const netIn = document.querySelector("[data-net-in]");
    if (netIn) netIn.value = "";
    const netView = document.querySelector("[data-net-view]");
    if (netView) {
      netView.innerHTML = "<p class=\"os-win__kicker\">HOUSE INTRANET</p><p class=\"os-win__copy\">nothing here right now. WIP</p>";
    }
    const a1 = document.querySelector("[data-a1-in]");
    if (a1) a1.value = "";
    const err = document.querySelector("[data-a1-err]");
    if (err) err.hidden = true;
    dispatchEvent(new CustomEvent("fh:reset"));
  };

  const BREAK_KEY = "fh.brk";
  let stormCtl = null;
  const q = (i) => (window.FH && window.FH.q && window.FH.q[i]) || "";
  let sfxBag = [];
  let sfxTimers = [];
  let sfxGen = 0;
  const laterSfx = (fn, ms) => {
    const id = setTimeout(fn, ms);
    sfxTimers.push(id);
    return id;
  };
  const killAud = (a) => {
    try {
      a.loop = false;
      a.pause();
      a.removeAttribute("src");
      a.src = "";
      a.load();
    } catch (_) { /* */ }
  };
  const stopSfx = () => {
    sfxGen += 1;
    sfxTimers.forEach(clearTimeout);
    sfxTimers = [];
    sfxBag.forEach(killAud);
    sfxBag = [];
  };
  const stopStormSfx = () => {
    sfxGen += 1;
    sfxTimers.forEach(clearTimeout);
    sfxTimers = [];
    const keep = [];
    sfxBag.forEach((a) => {
      if (a._bed) keep.push(a);
      else killAud(a);
    });
    sfxBag = keep;
  };
  let glitchVol = { ov1: 0.71, ov2: 1, ov3: 0.98 };
  const pullGlitch = (sfx) => {
    if (!sfx || typeof sfx !== "object") return;
    ["ov1", "ov2", "ov3"].forEach((k) => {
      if (sfx[k] == null || !isFinite(Number(sfx[k]))) return;
      glitchVol[k] = Math.max(0, Math.min(2, Number(sfx[k])));
    });
  };
  try {
    pullGlitch(JSON.parse(localStorage.getItem("fh-lab-v6") || "{}").sfx);
  } catch (_) { /* */ }
  const setAudVol = (a, v) => {
    if (window.FH && typeof window.FH.setHtmlVol === "function") window.FH.setHtmlVol(a, v);
    else a.volume = Math.max(0, Math.min(1, Number(v) || 0));
  };
  const applyGlitchVol = () => {
    sfxBag.forEach((a) => {
      if (a._kind && glitchVol[a._kind] != null) setAudVol(a, glitchVol[a._kind]);
    });
  };
  const makeSfx = (src, opts) => {
    if (!src || reduced) return null;
    const a = new Audio(src);
    a.preload = "auto";
    a.loop = !!(opts && opts.loop);
    const vol = opts && opts.vol != null ? opts.vol : 0.6;
    setAudVol(a, vol);
    if (opts && opts.bed) a._bed = true;
    if (opts && opts.kind) a._kind = opts.kind;
    sfxBag.push(a);
    a.play().catch(() => {});
    return a;
  };
  const startBrokenBed = () => {
    if (reduced) return;
    if (!document.body.classList.contains("is-broken")) return;
    const live = sfxBag.filter((a) => a._bed);
    if (live.length) {
      live.forEach((a) => {
        a.loop = true;
        if (a._kind && glitchVol[a._kind] != null) setAudVol(a, glitchVol[a._kind]);
        a.play().catch(() => {});
      });
      return;
    }
    makeSfx(q(7), { loop: true, vol: glitchVol.ov1, bed: true, kind: "ov1" });
    makeSfx(q(12), { loop: true, vol: glitchVol.ov3, bed: true, kind: "ov3" });
  };
  const pokeSfx = (src, vol) => {
    if (!src || reduced) return;
    const live = sfxBag.filter((x) => x._poke && !x.paused && !x.ended).length;
    if (live > 8) return;
    let a = sfxBag.find((x) => x._poke && (x.paused || x.ended));
    if (!a) {
      a = new Audio();
      a._poke = true;
      a.preload = "auto";
      sfxBag.push(a);
    }
    if (a._src !== src) {
      a.src = src;
      a._src = src;
    }
    a.loop = false;
    setAudVol(a, vol);
    try { a.currentTime = 0; } catch (_) { /* */ }
    a.play().catch(() => {});
  };
  const startStormSfx = () => {
    if (reduced) return;
    stopStormSfx();
    const gen = sfxGen;
    makeSfx(q(8), { loop: true, vol: glitchVol.ov2, kind: "ov2" });
    const alive = () => gen === sfxGen && document.body.classList.contains("is-storming");
    const spam = () => {
      if (!alive()) return;
      pokeSfx(q(9), 0.48 + Math.random() * 0.38);
      laterSfx(spam, 60 + Math.random() * 150);
    };
    const mid = () => {
      if (!alive()) return;
      pokeSfx(q(10), 0.4);
      laterSfx(mid, 720 + Math.random() * 1100);
    };
    const less = () => {
      if (!alive()) return;
      pokeSfx(q(11), 0.3);
      laterSfx(less, 2000 + Math.random() * 2600);
    };
    laterSfx(spam, 30);
    laterSfx(mid, 240);
    laterSfx(less, 800);
  };
  const ghostHost = () => {
    let host = document.querySelector(".os-ghosts");
    if (!host) {
      host = document.createElement("div");
      host.className = "os-ghosts";
      host.setAttribute("aria-hidden", "true");
      document.body.appendChild(host);
    }
    return host;
  };
  const spawnGhosts = () => {
    const host = ghostHost();
    host.innerHTML = "";
    host.dataset.ready = "1";
    const phone = phoneMq.matches;
    const spots = phone
      ? [[8, 10, 168], [48, 64, 156]]
      : [[58, 12, 220], [7, 62, 208]];
    const copy = [
      ["GPF", "This program has performed an illegal operation."],
      ["untitled", "The application is not responding."]
    ];
    spots.forEach((s, i) => {
      const el = document.createElement("aside");
      el.className = "os-ghost";
      el.style.left = s[0] + "vw";
      el.style.top = s[1] + "vh";
      el.style.width = s[2] + "px";
      el.innerHTML = `<div class="os-ghost__bar"><span>${copy[i][0]}</span><b>×</b></div><p class="os-ghost__body">${copy[i][1]}</p>`;
      host.appendChild(el);
    });
  };
  const breakDesk = () => {
    document.body.classList.add("is-broken");
    try { sessionStorage.setItem(BREAK_KEY, "1"); } catch (_) { /* */ }
    spawnGhosts();
    if (!document.querySelector(".os-break-veil")) {
      const veil = document.createElement("div");
      veil.className = "os-break-veil";
      veil.setAttribute("aria-hidden", "true");
      document.body.appendChild(veil);
    }
    dispatchEvent(new CustomEvent("fh:break"));
    startBrokenBed();
  };
  try {
    if (sessionStorage.getItem(BREAK_KEY) === "1") {
      breakDesk();
    }
  } catch (_) { /* */ }
  addEventListener("pagehide", () => {
    stopStormSfx();
    if (!document.body.classList.contains("is-broken")) stopSfx();
  });
  addEventListener("pageshow", () => {
    if (document.body.classList.contains("is-broken")) startBrokenBed();
  });
  document.addEventListener("visibilitychange", () => {
    if (!document.hidden && document.body.classList.contains("is-broken")) startBrokenBed();
  });
  ["pointerdown", "keydown", "touchstart"].forEach((ev) => {
    document.addEventListener(ev, () => {
      if (document.body.classList.contains("is-broken")) startBrokenBed();
    }, { capture: true });
  });
  addEventListener("fh:lab", (e) => {
    pullGlitch(e.detail && e.detail.sfx);
    applyGlitchVol();
  });

  const stormLaugh = (src, done, fromEl) => {
    breakDesk();
    if (reduced) {
      done && setTimeout(done, 400);
      return;
    }
    if (document.body.classList.contains("is-storming")) return;
    const raw = String(src || "");
    const url = raw.startsWith("//") ? ("https:" + raw) : raw;
    if (!url) {
      done && done();
      return;
    }
    document.body.classList.add("is-storming");
    startStormSfx();
    const host = document.createElement("div");
    host.className = "os-storm";
    host.setAttribute("aria-hidden", "true");
    document.body.appendChild(host);
    const phone = phoneMq.matches;
    const titles = ["WARNING", "ALERT", "untitled", "WIN32", "TROJAN", "???", "LAUGH.AVI", "GPF", "FATAL", "error", "kernel32", "0000", "SYSVOL", "VID_00", "FAULT"];
    const pops = [];
    const stormTimes = [];
    const born = Date.now();
    let n = 0;
    let finished = false;
    const laterStorm = (fn, ms) => {
      const id = setTimeout(fn, ms);
      stormTimes.push(id);
      return id;
    };
    const finish = (skipDone) => {
      if (finished && !skipDone) return;
      if (finished && skipDone) {
        stormTimes.forEach(clearTimeout);
        stormTimes.length = 0;
        pops.forEach((el) => el.remove());
        host.remove();
        document.body.classList.remove("is-storming");
        stopStormSfx();
        stormCtl = null;
        return;
      }
      if (!skipDone && Date.now() - born < 5000) {
        laterStorm(() => finish(false), 5000 - (Date.now() - born));
        return;
      }
      finished = true;
      stormTimes.forEach(clearTimeout);
      stormTimes.length = 0;
      if (skipDone) {
        pops.forEach((el) => el.remove());
        host.remove();
        document.body.classList.remove("is-storming");
        stopStormSfx();
        stormCtl = null;
        return;
      }
      const rest = pops.filter((el) => el.isConnected && !el.classList.contains("is-centre"));
      const centre = pops.filter((el) => el.isConnected && el.classList.contains("is-centre"));
      for (let i = rest.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        const tmp = rest[i];
        rest[i] = rest[j];
        rest[j] = tmp;
      }
      const gap = phone ? 58 : 44;
      rest.forEach((el, i) => {
        laterStorm(() => {
          el.classList.add("is-out");
          const vid = el.querySelector("video");
          laterStorm(() => {
            if (vid) {
              try { vid.pause(); vid.removeAttribute("src"); vid.load(); } catch (_) { /* */ }
            }
            el.remove();
          }, 520);
        }, i * gap);
      });
      const afterRest = rest.length * gap + 320;
      laterStorm(() => {
        centre.forEach((el) => {
          el.classList.add("is-out");
          laterStorm(() => el.remove(), 640);
        });
      }, afterRest);
      laterStorm(() => {
        host.remove();
        document.body.classList.remove("is-storming");
        stopStormSfx();
        stormCtl = null;
        done && done();
      }, afterRest + 780);
    };
    stormCtl = { cancel: () => finish(true) };
    const makeVid = (audio, at, hold) => {
      const vid = document.createElement("video");
      vid.setAttribute("playsinline", "");
      vid.setAttribute("webkit-playsinline", "");
      vid.playsInline = true;
      vid.muted = !audio;
      vid.loop = true;
      vid.preload = "auto";
      vid.src = url;
      if (audio) vid.volume = 1;
      const go = () => {
        try {
          if (vid.duration && isFinite(vid.duration)) {
            vid.currentTime = Math.max(0, Math.min(vid.duration * 0.92, (at || 0) * vid.duration));
          }
        } catch (_) { /* */ }
        if (hold) return;
        vid.play().catch(() => {
          vid.muted = true;
          vid.play().catch(() => {});
        });
      };
      if (vid.readyState >= 1) go();
      else vid.addEventListener("loadedmetadata", go, { once: true });
      return vid;
    };
    const spawn = (opts) => {
      if (finished) return;
      const el = document.createElement("aside");
      el.className = "os-storm__win" + (opts.audio ? " is-centre" : "") + (!opts.audio && Math.random() < 0.46 ? " is-red" : "");
      el.style.left = opts.x + "px";
      el.style.top = opts.y + "px";
      el.style.width = opts.w + "px";
      el.style.height = opts.h + "px";
      el.style.zIndex = String(opts.audio ? 236 : 180 + Math.floor(Math.random() * 40));
      el.innerHTML = `<div class="os-storm__bar"><span>${opts.audio ? "untitled" : titles[n % titles.length]}</span><button type="button" tabindex="-1">×</button></div><div class="os-storm__body"></div>`;
      n += 1;
      const vid = opts.vid || makeVid(!!opts.audio, opts.at);
      el.querySelector(".os-storm__body").appendChild(vid);
      host.appendChild(el);
      pops.push(el);
      el.querySelector("button").addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        el.classList.add("is-hit");
        setTimeout(() => el.classList.remove("is-hit"), 180);
      });
      if (opts.audio) {
        vid.loop = false;
        vid.addEventListener("ended", () => {
          if (vid.currentTime < 2) return;
          finish(false);
        });
        vid.addEventListener("error", () => setTimeout(() => finish(false), 6000));
      }
    };
    const slot = (big) => {
      if (big) {
        const w = Math.min(innerWidth * (phone ? 0.78 : 0.48), phone ? 280 : 520);
        const h = Math.round(w * 0.72);
        return {
          x: Math.max(8, (innerWidth - w) / 2),
          y: Math.max(12, (innerHeight - h) / 2),
          w,
          h
        };
      }
      const w = phone ? 100 + Math.random() * 150 : 128 + Math.random() * 260;
      const h = Math.round(w * (0.62 + Math.random() * 0.26));
      const x = Math.random() * (innerWidth - w * 0.45) - w * 0.12;
      const y = Math.random() * (innerHeight - h * 0.4) - h * 0.08;
      return { x, y, w, h };
    };

    const voice = makeVid(true, 0, true);
    const total = phone ? 44 : 68;
    let i = 0;
    const burst = () => {
      if (finished) return;
      if (i >= total) return;
      spawn(Object.assign({ audio: false, at: Math.random() }, slot(false)));
      i += 1;
      laterStorm(burst, phone ? 22 : 12);
    };
    burst();
    laterStorm(() => {
      if (finished) return;
      spawn(Object.assign({ audio: true, vid: voice, at: 0 }, slot(true)));
      try {
        voice.muted = false;
        voice.loop = false;
        voice.volume = 1;
        voice.play().catch(() => {
          voice.muted = true;
          voice.play().catch(() => {});
        });
      } catch (_) { /* */ }
    }, 3000);
    laterStorm(() => finish(false), 19000);
  };

  const mendDesk = () => {
    if (stormCtl && stormCtl.cancel) stormCtl.cancel();
    stopSfx();
    document.body.classList.remove("is-broken", "is-storming");
    try { sessionStorage.removeItem(BREAK_KEY); } catch (_) { /* */ }
    document.querySelectorAll(".os-ghosts, .os-break-veil, .os-storm").forEach((el) => el.remove());
    document.querySelectorAll(".is-faulting").forEach((el) => el.classList.remove("is-faulting"));
    document.body.classList.remove("is-gl-scan", "is-gl-grain", "is-gl-hard", "is-tearing");
    const mark = document.querySelector(".os-mark");
    if (mark) {
      mark.style.clipPath = "";
      mark.style.filter = "";
      mark.style.transform = "";
      mark.style.opacity = "";
    }
    document.querySelectorAll(".desk-top, .desk-bot, .desk-task, .os-file, .os-mark__plate").forEach((el) => {
      el.classList.remove("is-faulting", "is-corrupt");
      el.style.transform = "";
      el.style.filter = "";
      el.style.clipPath = "";
      el.style.opacity = "";
      const name = el.querySelector(".os-file__name");
      if (name && el.dataset.fhName) name.textContent = el.dataset.fhName;
    });
    document.querySelectorAll(".os-win.is-open").forEach((w) => closeWin(w));
    dispatchEvent(new CustomEvent("fh:mend"));
  };

  const reboot = (mode) => {
    if (document.body.classList.contains("is-rebooting")) return;
    document.body.classList.add("is-rebooting");
    if (stormCtl && stormCtl.cancel) stormCtl.cancel();
    const host = document.createElement("div");
    host.className = "os-reboot";
    host.setAttribute("role", "dialog");
    host.setAttribute("aria-label", mode === "shutdown" ? "Shutting down" : "Restarting");
    const wings = document.querySelector(".os-mark__wings");
    const mark = wings ? `<img class="os-reboot__wings" src="${wings.getAttribute("src")}" alt="">` : "";
    host.innerHTML = `${mark}<p class="os-reboot__msg">FIVEHEARTS OS is shutting down...</p><p class="os-reboot__safe" hidden>It is now safe<br>to turn off<br>your computer.</p><pre class="os-reboot__post" hidden></pre>`;
    document.body.appendChild(host);
    const msg = host.querySelector(".os-reboot__msg");
    const safe = host.querySelector(".os-reboot__safe");
    const post = host.querySelector(".os-reboot__post");
    const wait = (ms) => new Promise((r) => setTimeout(r, reduced ? Math.min(ms, 80) : ms));
    const tick = () => sfx("type");
    const lines = [
      "FIVEHEARTS BIOS  5.05",
      "Copyright (C) 1998-2005  HOUSE",
      "",
      "CPU      unknown",
      "Memory   32768K OK",
      "IDE 0    VOLUME C",
      "",
      "Detecting drives . . .",
      "",
      "Starting FIVEHEARTS OS . . ."
    ];
    const finish = () => {
      mendDesk();
      resetDesk();
      host.classList.add("is-out");
      setTimeout(() => {
        host.remove();
        document.body.classList.remove("is-rebooting");
      }, reduced ? 80 : 320);
    };
    (async () => {
      await wait(1550);
      if (mode === "shutdown") {
        msg.hidden = true;
        host.classList.add("is-safe");
        safe.hidden = false;
        await wait(2300);
        safe.hidden = true;
        host.classList.remove("is-safe");
      } else {
        msg.hidden = true;
      }
      post.hidden = false;
      host.classList.add("is-post");
      post.textContent = "";
      for (const line of lines) {
        post.textContent += line + "\n";
        if (line) tick();
        await wait(line ? 230 : 110);
      }
      await wait(920);
      finish();
    })();
  };

  if (!reduced) {
    let chaosTimer = 0;
    let markGen = 0;
    const markEl = () => document.querySelector(".os-mark");
    const phoneDesk = () => innerWidth <= 900;
    const clearMarkGlitch = () => {
      const el = markEl();
      if (!el) return;
      el.style.clipPath = "";
      el.style.filter = "";
      el.style.transform = "";
      el.style.opacity = "";
    };
    const pokeLogo = (storm) => {
      const el = markEl();
      if (!el) return;
      const id = ++markGen;
      const wander = Math.random() < 0.34;
      const phone = phoneDesk();
      const ox = (Math.random() > 0.5 ? 1 : -1) * (wander ? (phone ? 10 + Math.random() * 32 : 18 + Math.random() * 26) : (storm ? 4 + Math.random() * 10 : 2 + Math.random() * 6));
      const oy = (Math.random() > 0.5 ? 1 : -1) * (wander ? (phone ? 8 + Math.random() * 26 : 12 + Math.random() * 24) : (storm ? 3 + Math.random() * 8 : 1 + Math.random() * 5));
      const base = wander
        ? (phone ? `translate(${ox}vw, ${oy}vh)` : `translate(calc(-50% + ${ox}vw), calc(-50% + ${oy}vh))`)
        : (phone ? "none" : "translate(-50%, -50%)");
      const hold = wander
        ? 320 + Math.random() * (storm ? 1100 : 1600)
        : (storm ? 20 : 28) + Math.random() * (storm ? 280 : 520);
      const kind = Math.random();
      const x = (Math.random() - 0.5) * (storm ? 56 : 42);
      const y = (Math.random() - 0.5) * (storm ? 36 : 26);
      const rot = (Math.random() - 0.5) * (storm ? 18 : 12);
      const sx = 0.35 + Math.random() * 1.4;
      const sy = 0.28 + Math.random() * 1.55;
      const extra = wander ? "" : ` translate(${x}px, ${y}px)`;
      el.style.clipPath = "";
      el.style.filter = "";
      el.style.opacity = "";
      el.style.transform = base;
      if (kind < 0.12) {
        el.style.clipPath = Math.random() > 0.5
          ? `inset(${Math.random() * 58}% 0 ${Math.random() * 58}% 0)`
          : `inset(0 ${Math.random() * 48}% 0 ${Math.random() * 48}%)`;
        el.style.transform = wander ? base : `${base}${extra}`;
      } else if (kind < 0.24) {
        el.style.transform = `${base}${wander ? "" : extra} rotate(${rot}deg) scale(${sx}, ${sy})`;
      } else if (kind < 0.36) {
        const s = 1 + Math.random() * 16;
        el.style.filter = `drop-shadow(${s}px 0 #c4122e) drop-shadow(${-s}px 0 #f4f1ec) contrast(${1.1 + Math.random() * 1.4})`;
        if (!wander) el.style.transform = `${base} translateX(${x}px)`;
      } else if (kind < 0.44) {
        el.style.opacity = String(Math.random() * 0.2);
      } else if (kind < 0.56) {
        el.style.transform = `${base} skew(${(Math.random() - 0.5) * 42}deg, ${(Math.random() - 0.5) * 18}deg)`;
      } else if (kind < 0.68) {
        el.style.transform = `${base} scale(${sx}, ${sy})${wander ? "" : extra}`;
      } else if (kind < 0.8) {
        el.style.clipPath = `polygon(${Math.random() * 40}% ${Math.random() * 40}%, ${60 + Math.random() * 40}% ${Math.random() * 30}%, ${50 + Math.random() * 50}% ${60 + Math.random() * 40}%, ${Math.random() * 30}% ${70 + Math.random() * 30}%)`;
        el.style.transform = wander ? base : `${base}${extra}`;
      } else if (kind < 0.9) {
        el.style.filter = `hue-rotate(${Math.random() > 0.7 ? 0 : 180}deg) contrast(${2 + Math.random()}) invert(${Math.random() > 0.6 ? 1 : 0})`;
        el.style.transform = `${base}${wander ? "" : extra} rotate(${rot}deg)`;
      } else {
        el.style.clipPath = `inset(${Math.random() * 78}% 0 ${Math.random() * 30}% 0)`;
        el.style.transform = `${base}${wander ? "" : extra} scale(${sx}, ${sy})`;
        el.style.filter = "contrast(2.1)";
      }
      if (!wander || Math.random() > 0.45) {
        setTimeout(() => { if (id === markGen) clearMarkGlitch(); }, hold);
      }
    };
    const JUNK = ["NUL", "???", "ERR", "BAD", "0x00", "---", "LOST", "SYS", "????.EXE", "C0RRUPT"];
    const GLYPH = "█░▒▓¦|#?*_-/";
    const garble = (s) => {
      if (!s) return JUNK[Math.floor(Math.random() * JUNK.length)];
      if (Math.random() > 0.62) return JUNK[Math.floor(Math.random() * JUNK.length)];
      return [...s].map((ch) => {
        if (ch === " " && Math.random() > 0.4) return " ";
        if (Math.random() > 0.55) return GLYPH[Math.floor(Math.random() * GLYPH.length)];
        return Math.random() > 0.65 ? ch.toLowerCase() : ch;
      }).join("");
    };
    const restoreFile = (el) => {
      el.classList.remove("is-corrupt", "is-faulting");
      el.style.transform = "";
      el.style.filter = "";
      el.style.clipPath = "";
      el.style.opacity = "";
      const name = el.querySelector(".os-file__name");
      if (name && el.dataset.fhName) name.textContent = el.dataset.fhName;
    };
    const pokeFiles = (storm) => {
      const files = [...document.querySelectorAll(".os-file")].filter((el) => !el.classList.contains("is-held"));
      if (!files.length) return;
      const n = 1 + Math.floor(Math.random() * Math.min(files.length, storm ? 4 : 3));
      for (let i = 0; i < n; i++) {
        const el = files[Math.floor(Math.random() * files.length)];
        const nameEl = el.querySelector(".os-file__name");
        if (nameEl && !el.dataset.fhName) el.dataset.fhName = nameEl.textContent.trim();
        el.classList.add("is-corrupt");
        const kind = Math.random();
        el.style.filter = "";
        el.style.clipPath = "";
        el.style.opacity = "";
        if (kind < 0.18) {
          el.style.transform = `translate(${(Math.random() - 0.5) * (storm ? 90 : 64)}px, ${(Math.random() - 0.5) * (storm ? 70 : 48)}px) rotate(${(Math.random() - 0.5) * 22}deg)`;
        } else if (kind < 0.34) {
          el.style.transform = `skew(${(Math.random() - 0.5) * 38}deg, ${(Math.random() - 0.5) * 16}deg) scale(${0.55 + Math.random() * 0.9}, ${0.5 + Math.random() * 1.1})`;
        } else if (kind < 0.48) {
          el.style.filter = `invert(${Math.random() > 0.5 ? 1 : 0}) contrast(${1.4 + Math.random() * 1.6}) drop-shadow(${(Math.random() - 0.5) * 10}px 0 #c4122e)`;
          el.style.transform = `translate(${(Math.random() - 0.5) * 18}px, ${(Math.random() - 0.5) * 12}px)`;
        } else if (kind < 0.6) {
          el.style.clipPath = `inset(${Math.random() * 55}% 0 ${Math.random() * 55}% 0)`;
          el.style.transform = `translateX(${(Math.random() > 0.5 ? 1 : -1) * (8 + Math.random() * 28)}px)`;
        } else if (kind < 0.72) {
          el.style.opacity = String(0.05 + Math.random() * 0.35);
        } else {
          el.style.transform = `scale(${0.4 + Math.random() * 1.5}) rotate(${(Math.random() - 0.5) * 40}deg)`;
          el.style.filter = "contrast(2.2)";
        }
        if (nameEl && Math.random() > 0.28) nameEl.textContent = garble(el.dataset.fhName);
        const hold = 90 + Math.random() * (storm ? 480 : 780);
        setTimeout(() => {
          if (!document.body.classList.contains("is-broken")) {
            restoreFile(el);
            return;
          }
          if (Math.random() > 0.42) restoreFile(el);
        }, hold);
      }
      if (files.length > 1 && Math.random() > 0.7) {
        const a = files[Math.floor(Math.random() * files.length)];
        const b = files[Math.floor(Math.random() * files.length)];
        const an = a.querySelector(".os-file__name");
        const bn = b.querySelector(".os-file__name");
        if (an && bn && a !== b) {
          if (!a.dataset.fhName) a.dataset.fhName = an.textContent.trim();
          if (!b.dataset.fhName) b.dataset.fhName = bn.textContent.trim();
          const t = an.textContent;
          an.textContent = bn.textContent;
          bn.textContent = t;
        }
      }
    };
    const pokeChrome = () => {
      const nodes = [...document.querySelectorAll(".desk-top, .desk-bot, .desk-task, .os-mark__plate")];
      if (!nodes.length) return;
      const el = nodes[Math.floor(Math.random() * nodes.length)];
      if (Math.random() > 0.5) {
        el.classList.add("is-faulting");
        setTimeout(() => el.classList.remove("is-faulting"), 40 + Math.random() * 180);
      } else {
        el.style.transform = `translate(${(Math.random() - 0.5) * 12}px, ${(Math.random() - 0.5) * 8}px)`;
        setTimeout(() => { el.style.transform = ""; }, 35 + Math.random() * 150);
      }
    };
    const pokeFx = () => {
      const cls = Math.random() > 0.5 ? "is-gl-scan" : (Math.random() > 0.5 ? "is-gl-grain" : "is-gl-hard");
      document.body.classList.add(cls);
      setTimeout(() => document.body.classList.remove(cls), 35 + Math.random() * 170);
    };
    const runChaos = () => {
      clearTimeout(chaosTimer);
      if (!document.body.classList.contains("is-broken") || document.body.classList.contains("is-rebooting")) {
        clearMarkGlitch();
        document.querySelectorAll(".os-file.is-corrupt").forEach(restoreFile);
        chaosTimer = setTimeout(runChaos, 640);
        return;
      }
      const storm = document.body.classList.contains("is-storming");
      const hits = storm ? 1 + Math.floor(Math.random() * 4) : (Math.random() > 0.28 ? 1 : 1 + Math.floor(Math.random() * 3));
      for (let i = 0; i < hits; i++) {
        const pick = Math.random();
        if (pick < 0.42) pokeLogo(storm);
        else if (pick < 0.78) pokeFiles(storm);
        else if (pick < 0.9) pokeChrome();
        else pokeFx();
      }
      const burst = Math.random();
      const gap = storm
        ? (burst > 0.62 ? 8 + Math.random() * 40 : burst > 0.3 ? 50 + Math.random() * 180 : 160 + Math.random() * 420)
        : (burst > 0.72 ? 12 + Math.random() * 55 : burst > 0.38 ? 70 + Math.random() * 240 : 280 + Math.random() * 900);
      chaosTimer = setTimeout(runChaos, gap);
    };
    runChaos();
  }

  const bootConsent = () => {
    const bar = document.querySelector("[data-consent]");
    if (!bar) return;
    const KEY = "fh-consent-v1";
    const nativeSel = "#shopify-pc__banner, #shopify-pc-banner, section#shopify-pc__banner, shopify-cookie-banner, [id^='shopify-pc']";
    let watching = false;
    const readChoice = () => {
      try { return localStorage.getItem(KEY); } catch (_) { return null; }
    };
    const writeChoice = (v) => {
      try { localStorage.setItem(KEY, v); } catch (_) { /* */ }
      document.documentElement.classList.add("is-consent-done");
    };
    const hideNative = (root) => {
      (root || document).querySelectorAll(nativeSel).forEach((n) => {
        n.style.setProperty("display", "none", "important");
        n.setAttribute("hidden", "");
        n.setAttribute("aria-hidden", "true");
      });
    };
    const watchNative = () => {
      hideNative(document);
      if (watching) return;
      watching = true;
      const mo = new MutationObserver((muts) => {
        muts.forEach((m) => {
          m.addedNodes.forEach((n) => {
            if (!(n instanceof Element)) return;
            if (n.matches && n.matches(nativeSel)) hideNative(n.parentNode || document);
            else if (n.querySelector) hideNative(n);
          });
        });
      });
      mo.observe(document.documentElement, { childList: true, subtree: true });
    };
    const hideBar = () => {
      bar.hidden = true;
      document.documentElement.classList.add("is-consent-done");
      watchNative();
    };
    const syncShopify = (ok) => {
      const cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.setTrackingConsent !== "function") return;
      const payload = { analytics: ok, marketing: ok, preferences: true, sale_of_data: ok };
      try { cp.setTrackingConsent(payload, () => {}); }
      catch (_) {
        try { cp.setTrackingConsent(ok, () => {}); } catch (e) { /* */ }
      }
    };
    let bound = false;
    const bind = () => {
      if (bound) return true;
      bound = true;
      const saved = readChoice();
      if (saved) {
        hideBar();
        syncShopify(saved === "ok");
        return true;
      }
      watchNative();
      bar.hidden = false;
      const set = (ok) => {
        writeChoice(ok ? "ok" : "no");
        hideBar();
        syncShopify(ok);
      };
      bar.querySelector("[data-consent-ok]")?.addEventListener("click", () => set(true));
      bar.querySelector("[data-consent-no]")?.addEventListener("click", () => set(false));
      return true;
    };
    if (readChoice()) {
      hideBar();
    }
    if (bind()) {
      if (window.Shopify && typeof window.Shopify.loadFeatures === "function" && !window.Shopify.customerPrivacy) {
        window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], () => {
          const saved = readChoice();
          if (saved) syncShopify(saved === "ok");
        });
      }
      return;
    }
    if (window.Shopify && typeof window.Shopify.loadFeatures === "function") {
      window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], () => bind());
    }
  };
  bootConsent();

  window.FH = window.FH || {};
  window.FH.os = {
    openWin,
    closeWin,
    bindWin,
    bindFiles,
    layoutFiles,
    spawnFile,
    dropFile,
    openDoc: (key, fromEl) => openDoc(typeof key === "string" ? PAGES[key] : key, fromEl),
    syncTask,
    breakDesk,
    mendDesk,
    stormLaugh,
    reboot
  };
})();
